export enum LureStatus {
  DELIVERED = "DELIVERED",
  UNDELIVERED = "UNDELIVERED",
  SCHEDULED = "SCHEDULED",
}

export type LureSchedule = {
  user_uuid: string;
  user_name: string;
  user_email: string;
  lure_scheduled_at: string;
  lure_clicks_count: number;
  lure_subject: string;
  lure_status: keyof typeof LureStatus;
  lure_clicked_at: string;
  lure_reported_at?: string;
  uuid: string;
};
